<template lang="pug">
.mt-4
  v-layout.flex-column-phone(align-center, justify-space-between)
    h2 Gebruikersbeheer
    v-btn(color='primary', :to='{ name: "settings users details", params: { id: "new" } }') Nieuwe gebruiker

  v-progress-linear(indeterminate, v-if='!initialized')
  v-card.elevation-0.mt-4(v-else)
    v-data-table(
      :headers='headers',
      :items='users',
      :expand='true',
      item-key='id',
      :pagination.sync='pagination',
      :loading='loading',
      :must-sort='true',
      :rows-per-page-items='[10, 50]',
      hide-actions
      )
      template(slot='items', slot-scope='props')
        tr
          td {{ props.item.userInfo.initials }}

          td {{ props.item.userInfo.lastName }}

          td {{ props.item.email }}

          td.text-xs-right
            options
              v-list-tile(:to='{ name: "settings users details", params: { id: props.item.id } }')
                v-icon.mr-2(color='primary') fas fa-pen
                | Wijzigen

              //- v-list-tile(@click='deleteLease(props.item.id)')
                v-icon.mr-2(color='red darken-2') fas fa-trash-alt
                | Verwijderen

</template>

<script>
export default {
  components: {
    Options: require('@/components/Table/Options').default
  },

  data () {
    return {
      users: [],
      loading: false,
      initialized: false,

      headers: [
        {
          text: 'Voorletters',
          sortable: true,
          value: 'userInfo.initials'
        },
        {
          text: 'Achternaam',
          sortable: true,
          value: 'userInfo.lastName'
        },
        {
          text: 'Email',
          sortable: true,
          value: 'email'
        },
        {
          text: '',
          sortable: false
        }
      ],

      pagination: {
        sortBy: 'createdAt',
        descending: true
      }
    }
  },

  async created () {
    this.loading = true

    this.users = await this.$store.dispatch('graphqlQuery', {
      name: 'getUsers',
      variables: {
        orgId: this.$store.state.organization.currentOrgId
      }
    })

    this.loading = false

    this.initialized = true
  }
}
</script>

<style lang="scss" scoped>
</style>
